// extracted by mini-css-extract-plugin
module.exports = {"avatar":"pGE33ITV","normal":"KKsCHJiq","img":"RIfBao19","circle":"Mu_yx4MG","label":"OuPgQvwM","icon":"TmHRQrQF","text":"XQIQIXjt","fadeOut":"itLOKtit"};